import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
import CurrencyFormat from 'react-currency-format';
import { getContractDocumentById, getFMSContractByFranchiseId } from '@app/services/FMScontracts';
import PreviewModal from '../../ops-manual/PreviewModal';
import { getExtension } from '@app/services/opsManual';
import { encodeId } from '@app/helpers/base64url';
import { useDecodedParam } from '@app/hooks/useDecodedParam';
import fileDownload from 'js-file-download';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import { getDBSDocumentById, getDBSUsersByFranchiseId } from '@app/services/user';

const ViewFMSContract = () => {

    let obj: any = {}
    const financingTypes = [{value: 'yes' , name:'Yes'}, {value: 'no', name:'No'}, {value: 'yes-but-failed', name:'Yes but failed'}]
    const [isLoading, setLoading] = useState(false);
    const [contract, setContractData] = useState(obj);
    const [franchise, setFranchise] = useState(obj);
    const [franchisee, setFranchisee] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [url, setUrl] = useState('');
    const [filename, setFileName] = useState('');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const canAccess = useSelector((state: any) => state.auth.permissions.franchise);
    const canAccessDBS = useSelector((state: any) => state.auth.permissions.users);
    const navigate = useNavigate();
    const id = useDecodedParam('encodedId', '/franchise');
    
    useEffect(() => {
        getContractByFranchiseId(id)
        getAllDBSUsersByFranchiseId(id)

        return () => {
            setContractData(obj)
            setDocuments([])
        }
    }, []);

    useEffect(() => {
        if(!show){
            setUrl('')
            setFileName('')
        }
    }, [show]);

    const getContractByFranchiseId = async (id) => {
        try {
            setLoading(true);
            const resp = await getFMSContractByFranchiseId(id);
            if(resp.success === true){
                setLoading(false);
                setFranchise(resp?.collections?.franchise)
                if(Object.keys(resp?.collections?.contract).length > 0){
                    setContractData(resp?.collections?.contract);
                    setDocuments(resp?.collections?.contract?.documents.filter((doc) => doc.type == 'contract_documents'))
                }
            }else{
                setLoading(false);
                toast.error(resp?.message || 'Something went wrong');
                navigate('/franchise');
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Something went wrong');
        }
    };

    const previewFile = async (type, docId, name) => {
        try{
            let resp
            if(type == 'dbs')    
                resp = await getDBSDocumentById(docId)
            else
                resp = await getContractDocumentById(docId)
            
            setUrl(URL.createObjectURL(resp))
            setFileName(name)
            handleShow();

        } catch (error) {
            setLoading(false);
            console.log(error)
        }
    }

    const downloadDocument = async (type, docId, name) => {
        try{
            let resp
            if(type == 'dbs')    
                resp = await getDBSDocumentById(docId)
            else
                resp = await getContractDocumentById(docId)

            fileDownload(resp, name);
            setLoading(false);        
        } catch (error) {
            setLoading(false);
            console.log(error)
        }
    }

    const getAllDBSUsersByFranchiseId = async (id) => {
        try {
            const resp = await getDBSUsersByFranchiseId(id);
            if(resp.success === true){
                setFranchisee(resp?.collections)
            }else{
                toast.error(resp?.message || 'Something went wrong');
                navigate('/franchise');
            }
        } catch (error: any) {
            toast.error(error?.message || 'Something went wrong');
        }
    };

  return (
    <div>
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        {canAccess['view-contract'] && (
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">View Franchise Agreement Details - { franchise?.name } </h3>
                            </div>
                            <div className="card-body">
                                
                                {Object.keys(contract).length == 0 && (
                                    <div className='col-md-12'>
                                        <span className='text-danger'>No agreement has been added for this franchise.</span>
                                    </div>
                                )}
                                { Object.keys(contract).length > 0 && (
                                    <>
                                    <div className="row">
                                        <dt className="col-sm-3">Franchise Details</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Franchise Name </dt>
                                                <dd>{ contract?.name ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Kashflow License Code </dt>
                                                <dd>{ contract?.kashflow_license_account ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Billing Start Date As Per Kashflow </dt>
                                                <dd>{ contract?.kashflow_billing_start_date ? moment(contract?.kashflow_billing_start_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Contract</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Contract Term 11.1 (Years)</dt>
                                                <dd>{ contract?.contract_term ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Contracted Initial Fee </dt>
                                                <dd>{ contract?.contract_initial_fee ? <CurrencyFormat value={ contract?.contract_initial_fee  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Commencement Date As Per Contract </dt>
                                                <dd>{ contract?.contract_commencement_date ? moment(contract?.contract_commencement_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Renewal</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Renewal Fee (Under 'Term' in Contract) </dt>
                                                <dd>{ contract?.renewal_fee ? <CurrencyFormat value={ contract?.renewal_fee  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Renewal Date </dt>
                                                <dd>{ contract?.renewal_date ? moment(contract?.renewal_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Deposit</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Deposit As Per Proposed Letter </dt>
                                                <dd>{ contract?.deposit_amount ? <CurrencyFormat value={ contract?.deposit_amount  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Deposit Paid Date </dt>
                                                <dd>{ contract?.deposit_paid_date ? moment(contract?.deposit_paid_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Initial Fee Balance Due Arrangements</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Plan/Financed Amount <i className='fa fa-info-circle' title='By straight cash, as per proposed letter'/></dt>
                                                <dd>{ contract?.plan_financed_amount ? <CurrencyFormat value={ contract?.plan_financed_amount  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Financing </dt>
                                                <dd>{ contract?.financing ? (financingTypes.find(obj => { return obj.value === contract?.financing}))?.name : '---' } </dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Special Payment Terms <i className='fa fa-info-circle' title='To claim initial fee portion via alt growth mechanism'/> </dt>
                                                <dd>{ contract?.special_payment_amount ? <CurrencyFormat value={ contract?.special_payment_amount  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Standard Fees</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Monthly Franchise Fee </dt>
                                                <dd>{ contract?.monthly_franchise_fees ? <CurrencyFormat value={ contract?.monthly_franchise_fees  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Monthly Student Fee Before </dt>
                                                <dd>{ contract?.monthly_student_fee_before ? <CurrencyFormat value={ contract?.monthly_student_fee_before  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Monthly Student Fee After </dt>
                                                <dd>{ contract?.monthly_student_fee_after ? <CurrencyFormat value={ contract?.monthly_student_fee_after  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Non-Standard Fees</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Monthly Student Fee Tier 2 </dt>
                                                <dd>{ contract?.monthly_student_fee_tier_two ? <CurrencyFormat value={ contract?.monthly_student_fee_tier_two  } decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={ contract?.currency + ' '} /> : '---'}</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>Subjects To </dt>
                                                <dd>{ contract?.subject_to ?? '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">FMS Dates</dt>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>FMS Start Date (Management's reported date) </dt>
                                                <dd>{ contract?.start_date ? moment(contract?.start_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>FMS Effective Start Date </dt>
                                                <dd>{ contract?.effective_start_date ? moment(contract?.effective_start_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <dt>FMS End Date </dt>
                                                <dd>{ contract?.end_date ? moment(contract?.end_date).format('DD-MMM-YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className="row">
                                        <dt className="col-sm-3">Contract Repository</dt>
                                        {documents.length > 0 && (
                                            <div className='col-sm-9'> 
                                            <table className="table table-bordered" id="client_id_table">
                                                <tbody>
                                                    <tr className='text-center'>
                                                        <th>Document</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {documents.length > 0 && documents.map(file => (
                                                        <tr key={file?.id}>
                                                            <td>
                                                                <a href='javascript:void(0)' onClick={ (e) => { downloadDocument('contract', file?.id, file?.document_name)} } data-toggle="tooltip" title="Preview" className='mx-3'> 
                                                                    {file?.document_name}
                                                                </a>
                                                            </td>
                                                            <td className='pl-5'>
                                                                <a href='javascript:void(0)' onClick={ (e) => { downloadDocument('contract', file?.id, file?.document_name)} } data-toggle="tooltip" title="Download Document">
                                                                    <i className="fas fa-download mr-2"></i>
                                                                </a> 
                                                                { (['docx', 'doc', 'xlsx', 'xls', 'wav'].findIndex((ext) => ext == getExtension(file?.document_name))) < 0 &&
                                                                    <a href='javascript:void(0)'
                                                                    onClick={ (e) => { previewFile('contract', file?.id, file?.document_name)} }
                                                                        data-toggle="tooltip" title="Preview Document">
                                                                        <i className="fas fa-eye fa-sm mr-2"/>
                                                                    </a>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            </div>
                                        )}
                                        {documents.length == 0 && (
                                            <span className='text-danger'>No greement documents have been uploaded for this franchise.</span>
                                        )}
                                    </div>
                                    </>
                                )}
                            </div>
                            <div className="card-footer">
                                { canAccess['add-contract'] && Object.keys(contract).length == 0 &&
                                    <Link className="btn btn-primary mr-2" to={`/franchise/add-contract/${encodeId(id)}`}>Add Franchise Agreement</Link>
                                }
                                { canAccess['edit-contract'] && Object.keys(contract).length > 0 &&
                                    <Link className="btn btn-primary mr-2" to={`/franchise/edit-contract/${encodeId(id)}`}>Edit Franchise Agreement</Link>
                                }
                                <Link className="btn btn-default" to='/franchise'>Close</Link>
                            </div>
                        </div>
                        )}
                    </div>
                    {canAccessDBS['view-dbs'] && (
                        <>
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <div className="card-header">
                                    <h3 className="card-title">Franchisee(s) DBS Details - { franchise?.name }</h3>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            { franchisee.length > 0 && (
                                            <Tab.Container id="left-tabs-example" defaultActiveKey="0">
                                                <Row>
                                                    <Col sm={3}>
                                                        <Nav variant="tabs" className="flex-column">
                                                            { franchisee.length && franchisee.map((user, i) => (
                                                                <Nav.Item>
                                                                    <Nav.Link eventKey={ i }>{ user?.name } &nbsp; &nbsp;
                                                                        { canAccessDBS['update-dbs'] && (
                                                                        <Link
                                                                            to={`/users/dbs`}
                                                                            role="button"
                                                                            state={{ id: user?.id, userName: user?.name }}
                                                                            data-toggle="tooltip" title="Update DBS Cert Details"
                                                                        >
                                                                            <i className="fas fa-edit mr-2"/>
                                                                        </Link>
                                                                        )}  <br/>
                                                                        <span className='text-muted'><small> { user?.roles }</small></span>
                                                                    </Nav.Link>
                                                                </Nav.Item>
                                                            ))}
                                                        </Nav>
                                                    </Col>
                                                    <Col sm={9}>
                                                        <Tab.Content>
                                                            { franchisee.length && franchisee.map((user, i) => (
                                                                <Tab.Pane eventKey={ i }>
                                                                    <div className="row ml-2">
                                                                        {Object.keys(user?.dbs).length == 0 && (
                                                                            <div className='col-md-12'>
                                                                                <span className='text-danger'>User DBS details have not been updated.</span>
                                                                            </div>
                                                                        )}
                                                                        {Object.keys(user?.dbs).length > 0 && (
                                                                            <>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>DBS Cert. Date </dt>
                                                                                    <dd>{ user?.dbs?.cert_date ? moment(user?.dbs?.cert_date).format('DD/MM/YYYY') : '---' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>DBS Cert. Number </dt>
                                                                                    <dd>{ user?.dbs?.cert_number ?? '---' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>DOB For Update Service Check </dt>
                                                                                    <dd>{ user?.dbs?.update_service_check_date ? moment(user?.dbs?.update_service_check_date).format('DD/MM/YYYY') : '---' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>Update Service </dt>
                                                                                    <dd>{ user?.dbs?.update_service ? 'Yes' : 'No' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>DBS Cert Copy Held? </dt>
                                                                                    <dd>{ user?.dbs?.status_issues ? 'Yes' : 'No' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div className="form-group">
                                                                                    <dt>Surname Per DBS Cert For Update Service Check </dt>
                                                                                    <dd>{ user?.dbs?.surname_cert ?? '---' }</dd>
                                                                                </div>
                                                                            </div>
                                                                            {user?.dbs?.documents.length > 0 && (
                                                                                <div className='col-sm-12'> 
                                                                                    <table className="table table-bordered" id="client_id_table">
                                                                                        <tbody>
                                                                                            <tr className='text-center'>
                                                                                                <th>Document</th>
                                                                                                <th>Action</th>
                                                                                            </tr>
                                                                                            {user?.dbs?.documents.length > 0 && user?.dbs?.documents.map(file => (
                                                                                                <tr key={file?.id}>
                                                                                                    <td>
                                                                                                        <a href='javascript:void(0)' onClick={ (e) => { downloadDocument('dbs', file?.id, file?.name)} } data-toggle="tooltip" title="Preview" className='mx-3'> 
                                                                                                            {file?.name}
                                                                                                        </a>
                                                                                                    </td>
                                                                                                    <td className='pl-5'>
                                                                                                        <a href='javascript:void(0)' onClick={ (e) => { downloadDocument('dbs', file?.id, file?.name)} } data-toggle="tooltip" title="Download Document">
                                                                                                            <i className="fas fa-download mr-2"></i>
                                                                                                        </a> 
                                                                                                        { (['docx', 'doc', 'xlsx', 'xls', 'wav'].findIndex((ext) => ext == getExtension(file?.name))) < 0 &&
                                                                                                            <a href='javascript:void(0)'
                                                                                                            onClick={ (e) => { previewFile('dbs', file?.id, file?.name)} }
                                                                                                                data-toggle="tooltip" title="Preview Document">
                                                                                                                <i className="fas fa-eye fa-sm mr-2"/>
                                                                                                            </a>
                                                                                                        }
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            )}
                                                                            {user?.dbs?.documents.length == 0 && (
                                                                                <span className='text-danger'>No DBS document(s) have been uploaded.</span>
                                                                            )}
                                                                            </> 
                                                                        )}
                                                                    </div>
                                                                </Tab.Pane>
                                                            ))}
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </section>
        <PreviewModal
            show={show}
            handleClose={handleClose}
            url={url}
            filename={filename}
        />
    </div>
  )
}

export default ViewFMSContract;